<script setup>
import { reactive } from 'vue';
import SportLiveTvCatalogEvents from '@/sport-live-tv/components/sport-live-tv-catalog-events.vue';
import SportLiveTvError from '@/sport-live-tv/components/sport-live-tv-error.vue';
import SportLiveTvFilters from '@/sport-live-tv/components/sport-live-tv-filters.vue';
import SportLiveTvLoading from '@/sport-live-tv/components/sport-live-tv-loading.vue';
import { useSportLiveTvFilters } from '@/sport-live-tv/composables/use-sport-live-tv-filters';
import { useSportLiveTvRows } from '@/sport-live-tv/composables/use-sport-live-tv-rows';
import { useSportLiveTvSelectionEvents } from '@/sport-live-tv/composables/use-sport-live-tv-selection-events';
import { useSportLiveTvTeams } from '@/sport-live-tv/composables/use-sport-live-tv-teams';

const { applied, draft, sort, status, scoresVisible, teamsSearch, debouncedTeamsSearch, isFiltered, toggle, applyFilters, selectLeague, showLive, toggleScores, clearFilters } =
  useSportLiveTvFilters();

const { categories, rows, featured, live, isLoading, isError, refetch } = useSportLiveTvRows({ status, sort, isFiltered });

const selectionEvents = reactive(useSportLiveTvSelectionEvents({ selection: applied, status, sort }));

const teams = useSportLiveTvTeams(debouncedTeamsSearch);
</script>

<template>
  <SportLiveTvError v-if="isError" @retry="refetch" />
  <SportLiveTvLoading v-else-if="isLoading" />
  <template v-else>
    <SportLiveTvFilters
      v-model:sort="sort"
      v-model:status="status"
      v-model:teams-search="teamsSearch"
      :categories="categories"
      :teams="teams"
      :draft="draft"
      :scores-visible="scoresVisible"
      @toggle="toggle"
      @apply="applyFilters"
      @clear="clearFilters"
      @toggle-scores="toggleScores"
    />
    <SportLiveTvCatalogEvents
      :is-filtered="isFiltered"
      :selection-events="selectionEvents"
      :featured="featured"
      :live="live"
      :categories="rows"
      :scores-visible="scoresVisible"
      @clear-filters="clearFilters"
      @select-category="selectLeague"
      @show-live="showLive"
    />
  </template>
</template>
